import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ProviderListItemVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminRetrieveProviders = createAsyncThunk<ProviderListItemVM[], void, { extra: Partial<Dependencies> }>(
  "providers/adminRetrieveProviders",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listProviders();
  },
);
